var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-overlay"},[_c('div',{staticClass:"modal-content"},[_c('h2',[_vm._v("Aviso")]),_c('p',[_vm._v(_vm._s(_vm.message))]),_c('button',{staticClass:"btn-ok",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("OK")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }